/**
 * @fileoverview TThis helper is will be used by Remix only at a client-side due to .client.ts extension Remix convention.
 */

import { isMobileUserAgent } from './isMobileUserAgent';
import { MOBILE_MAX_WIDTH } from './consts';

/**
 * Check if the app is running in a web app in iOS
 *
 * @returns {boolean} True if the app is running in a web app in iOS
 */
export const isInWebAppiOS = (window.navigator as any).standalone === true;

/**
 * Check if the app is running in a web app in Chrome
 * This is a workaround for the lack of support for display-mode in Chrome
 *
 * @returns {boolean} True if the app is running in a web app in Chrome
 */
export const isInWebAppChrome = window.matchMedia('(display-mode: standalone)').matches;

export const isMobileDeviceByUserAgent = () =>
  isMobileUserAgent(navigator.userAgent || navigator.vendor || String((window as Window & { opera?: unknown }).opera ?? ''));

export const checkScreenSize = () => (window.innerWidth < MOBILE_MAX_WIDTH || isMobileDeviceByUserAgent() ? true : false);
